import './index.css';
import { BrowserRouter, Routes, Route } from "react-router-dom"
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-loading-skeleton/dist/skeleton.css'
import Login from './pages/login/Login';
import Dashboard from './pages/dashboard/Dashboard';
import NotFound from './pages/notfound/NotFound';
import { useState } from 'react';

function App() {
  const serverURL = "https://ddbc.dentaldirektindia.com"
  // const serverURL = "http://localhost:8443"
  const [user, setUser] = useState({});
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Login serverURL={serverURL} user={user} setUser={setUser} />} />
          <Route exact path="/dashboard" element={<Dashboard serverURL={serverURL} user={user} setUser={setUser} />} />
          <Route exact path="*" element={<NotFound serverURL={serverURL} />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
